import React from "react";
import styled from "styled-components";

const IncomeTable = () => {
  return (
    <StyledTable>
      <thead>
        <tr>
          <th scope="col">Household Size</th>
          <th scope="col">Minimum Income</th>
          <th scope="col">Maximum Income</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>$33,950</td>
          <td>$54,250</td>
        </tr>
        <tr>
          <td>2</td>
          <td>$38,800</td>
          <td>$62,000</td>
        </tr>
        <tr>
          <td>3</td>
          <td>$43,650</td>
          <td>$69,750</td>
        </tr>
        <tr>
          <td>4</td>
          <td>$48,450</td>
          <td>$77,500</td>
        </tr>
        <tr>
          <td>5</td>
          <td>$52,350</td>
          <td>$83,700</td>
        </tr>
        <tr>
          <td>6</td>
          <td>$56,250</td>
          <td>$89,900</td>
        </tr>
        <tr>
          <td>7</td>
          <td>$60,100</td>
          <td>$96,100</td>
        </tr>
        <tr>
          <td>8</td>
          <td>$64,000</td>
          <td>$102,300</td>
        </tr>
      </tbody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  th,
  td {
    padding: 12px;
    border: 1px solid #ddd;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
  }
`;

export default IncomeTable;
